import { useState, useId, type FC } from "react";
import {
  TextInput,
  FormControl,
  Label,
  type TextInputProps,
  type FormControlProps,
} from "@uhg-harmony/react";

interface ValidatedTextInputProps
  extends TextInputProps, Omit<FormControlProps, "children" | "id"> {
  id?: string;
  label?: string;
  forceBlurred?: boolean;
}

export const ValidatedTextInput: FC<ValidatedTextInputProps> = ({
  id,
  label,
  width,
  className,
  disabled,
  required,
  errorMsgOrientation,
  placeholder,
  autoFocus,
  value = "",
  onChange,
  forceBlurred = false,
}) => {
  const [blurred, setBlurred] = useState(false);
  const uniqueId = useId();
  const isBlurred = blurred || forceBlurred;
  const error =
    (value as string).length === 0 && isBlurred ? "Input is required" : "";

  const handleBlur = () => {
    setBlurred(true);
  };

  return (
    <FormControl
      id={id ?? uniqueId}
      error={error}
      required={required}
      disabled={disabled}
      errorMsgOrientation={errorMsgOrientation}
    >
      <Label required={required}>{label}</Label>
      <TextInput
        onChange={onChange}
        onBlur={handleBlur}
        value={value}
        width={width}
        className={className}
        placeholder={placeholder}
        autoFocus={autoFocus}
        disabled={disabled}
      />
    </FormControl>
  );
};
